import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	zero_query: {
		id: 'search_dialog_zero_query',
		defaultMessage: 'Suggested',
		description: 'Label for suggested search queries',
	},
	zero_query_icon_label: {
		id: 'search_dialog_zero_query_icon_label',
		defaultMessage: 'Suggested search',
		description: 'Assistive label for suggested search queries',
	},
});
